import url from './url';



export default url(() => '/achievements');
